<template>
  <span>
    <b-modal
      id="item-info-modal"
      ref="itemInfoModal"
      v-model="show"
      size="lg"
      hide-footer
      @hide="closeModal()"
    >
      <template #modal-header>
        <div class="flex justify-between w-full">
          <div>
            <h5>
              {{ item.description }}
            </h5>
          </div>
          <b-button variant="link" @click.prevent="closeModal()">
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>

      <div v-if="item.images" class="d-block">
        <div class="product-image">
          <image-slider :images="item.images" />
        </div>

        <b-tabs content-class="mt-3">
          <b-tab :title="$t('productDescription')" active>
            <p v-html="item.mediumDescription"
          /></b-tab>
          <b-tab v-if="item.properties.length" :title="$t('productProperties')">
            <b-table :items="item.properties" thead-class="d-none" />
          </b-tab>

          <b-tab v-if="item.videos.length" title="Videos">
            <iframe
              v-for="video in item.videos"
              :key="video"
              width="100%"
              height="500px"
              :src="video"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </b-tab>
        </b-tabs>
      </div>
      <div class="w-100 d-flex flex-row-reverse">
        <b-button id="show-btn" block @click="openAddToCartModal()"
          ><i class="fas fa-cart-plus"></i> {{ $t("addToCart") }}
        </b-button>
      </div>
    </b-modal>
  </span>
</template>

<script>
import ImageSlider from "../image/ImageSlider.vue"
import api from "@/services/api"
import { BButton, BModal, BTable, BTabs, BTab } from "bootstrap-vue"
import { mapGetters } from "vuex"

export default {
  name: "ProductModalInfo",
  components: {
    "image-slider": ImageSlider,
    BButton,
    BModal,
    BTable,
    BTabs,
    BTab,
  },
  props: {
    itemid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      item: {},
      variant: "",
    }
  },
  computed: {
    ...mapGetters({
      showModal: "itemModal/showModal",
      type: "itemModal/type",
      itemid: "itemModal/itemId",
    }),
    show() {
      if (this.showModal && this.type === "info") {
        return true
      }
      return false
    },
  },
  created() {
    this.fetchItemData()
  },
  methods: {
    openAddToCartModal() {
      this.$store.commit("itemModal/setType", "add-to-cart")
    },
    closeModal() {
      this.$store.commit("itemModal/hideModal")
    },
    async fetchItemData() {
      window.location.hash = `info-${this.itemid}`

      if (Object.keys(this.item).length === 0) {
        // Only get item data if we do not already have it
        await this.getItemData()
      }
    },
    async getItemData() {
      const requestData = await api.get("/api/v1/items", {
        params: {
          ItemID: this.itemid,
        },
      })

      this.item = requestData.data
    },
  },
}
</script>

<style>
.tabs {
  border: none;
}
.nav-tabs {
  margin-left: 0;
}
</style>
